<template>
  <svg
    id="Layer_1"
    width="52px"
    height="52px"
    :class="[size, color]"
    viewBox="0 0 52 52"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M50,24H6.83L27.41,3.41a2,2,0,0,0,0-2.82,2,2,0,0,0-2.82,0l-24,24a1.79,1.79,0,0,0-.25.31A1.19,1.19,0,0,0,.25,25c0,.07-.07.13-.1.2l-.06.2a.84.84,0,0,0,0,.17,2,2,0,0,0,0,.78.84.84,0,0,0,0,.17l.06.2c0,.07.07.13.1.2a1.19,1.19,0,0,0,.09.15,1.79,1.79,0,0,0,.25.31l24,24a2,2,0,1,0,2.82-2.82L6.83,28H50a2,2,0,0,0,0-4Z"
    />
  </svg>
  <!-- <svg xmlns="http://www.w3.org/2000/svg" :class="[size, color]" viewBox="0 0 20 20"><path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2ZM10,17,5,12l1.41-1.41L10,14.17l7.59-7.59L19,8Z" transform="translate(-2 -2)"/></svg> -->
</template>

<script>
export default {
  name: "CheckIcon",
  props: {
    size: {
      type: String,
      default: "medium",
      validator: function (value) {
        // The value must match one of these strings
        return ["medium"].includes(value);
      },
    },
    color: {
      type: String,
      default: "orange",
      validator: function (value) {
        // The value must match one of these strings
        return ["orange"].includes(value);
      },
    },
  },
};
</script>

<style scoped>
.medium {
  width: 24px;
  height: 24px;
}
.orange path {
  fill: #d9835e;
}
</style>
